import { useTranslation } from 'react-i18next'

import { EMPTY_FUNCTION } from '../../../constants/common'
import { SIZE } from '../../../constants/size'
import { useNotification, useTimeZone } from '../../../hooks'
import { ConfirmationModal } from '../../Confirmation'
import Text from '../../Text'
import { answerAppointmentFollowUp } from '../Appointment.api'

import { QA_NAME_APPOINTMENT_FOLLOW_UP_MODAL } from './AppointmentFollowUpModal.constants'
import {
  getAppointmentFollowUpApplyData,
  getAppointmentFollowUpBeforeKey,
  getAppointmentFollowUpDateLabel,
  getAppointmentFollowUpReasonKey,
  getAppointmentFollowUpRequestLabel,
} from './AppointmentFollowUpModal.utils'
import { AppointmentFollowUpModalButtons } from './AppointmentFollowUpModalButtons'

import * as styles from './AppointmentFollowUpModal.module.css'

function AppointmentFollowUpModal({
  appointment,
  onApplied = EMPTY_FUNCTION,
  onClose,
}) {
  const { t } = useTranslation()

  const timezone = useTimeZone()

  const { handleAddErrorNotification } = useNotification()

  const prompt = appointment.follow_up_prompt

  async function handleApply() {
    return answerAppointmentFollowUp({
      data: getAppointmentFollowUpApplyData(prompt),
      id: appointment.id,
    })
      .then(() => {
        onApplied(appointment)
        onClose()
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
        onClose()
      })
  }

  return (
    <ConfirmationModal
      ActionButtons={AppointmentFollowUpModalButtons}
      actionButtonsProps={{
        cancelText: t('Appointment.CouplingDeclineKey'),
        submitText: t('Appointment.CouplingConfirmKey'),
      }}
      boxSize={SIZE.LARGE}
      description={getAppointmentFollowUpRequestLabel(prompt.request)}
      qaName={QA_NAME_APPOINTMENT_FOLLOW_UP_MODAL}
      title={t('Appointment.CouplingTitleKey')}
      onCancel={onClose}
      onSubmit={handleApply}
    >
      <div className={styles.lines}>
        <Text>
          {t(getAppointmentFollowUpBeforeKey(prompt), {
            value: getAppointmentFollowUpDateLabel({
              date: prompt.current_due_date,
              timezone,
            }),
          })}
        </Text>
        <Text>
          {t('Appointment.CouplingNewKey', {
            value: getAppointmentFollowUpDateLabel({
              date: prompt.target_due_date,
              timezone,
            }),
          })}
        </Text>
        <Text isSecondary>{t(getAppointmentFollowUpReasonKey(prompt))}</Text>
      </div>
    </ConfirmationModal>
  )
}

export default AppointmentFollowUpModal
